import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { getComponent, getContextModules } from "@/lib/requireContextHelpers";
import { default as DefaultIntegration } from "./NotificationItemView.vue";

const modules = getContextModules(require.context("./components", true, /\.\/Notification[a-zA-Z]*\/index.ts/));

export default function getNotificationItem(notification: Notification | null) {
  return getComponent(modules, notification, DefaultIntegration);
}
